import { useNavigate } from 'react-router-dom';
import {
  Container,
  Header,
  Button,
  SpaceBetween,
  Box,
  Alert,
  Link,
  ContentLayout
} from '@cloudscape-design/components';
import BaseAppLayout from '@@/products/portal/components/base-app-layout';

function UnauthorizedPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Navigate to home page
    navigate('/');
  };

  const content = (
    <ContentLayout
      header={
        <Header variant='h1' description="You don't have permission to access this resource">
          Access Denied
        </Header>
      }
    >
      <Container>
        <SpaceBetween size='l'>
          <Alert type='error' header='Unauthorized access'>
            You don't have the necessary permissions to view this page. This may be because:
            <ul>
              <li>Your user account doesn't have the required role or permissions</li>
              <li>You need to request access from your administrator</li>
              <li>You might need to log out and log back in with different credentials</li>
            </ul>
          </Alert>

          <Box>
            If you believe you should have access to this page, please contact your administrator or{' '}
            <Link href='mailto:support@example.com'>support team</Link>.
          </Box>

          <Button onClick={handleGoHome} variant='primary' ariaLabel='Go Home'>
            Go Home
          </Button>
        </SpaceBetween>
      </Container>
    </ContentLayout>
  );
  // Wrap the content with BaseAppLayout to show the navbar
  return <BaseAppLayout content={content} />;
}

export default UnauthorizedPage;
